import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Checklist, Field } from '@itds/elements/index.js';
import {
  GUARANTEED_UNIVERSAL_LIFE_PRODUCTS,
  OTHER_PRODUCTS,
  ROP_PRODUCTS,
  TERM_LIFE_INSURANCE_PRODUCTS
} from '@itds/Constants';

const LimitProductTypes = ({ ltc_quoter, quoter, handleSave }) => {
  const all_product_types = [
    ...TERM_LIFE_INSURANCE_PRODUCTS,
    ...GUARANTEED_UNIVERSAL_LIFE_PRODUCTS,
    ...ROP_PRODUCTS,
    ...OTHER_PRODUCTS
  ];

  // Use quoter if present (Universal Quoter), else fallback to ltc_quoter
  const initialProductTypes =
    (quoter && quoter.product_types) ||
    (ltc_quoter && ltc_quoter.product_types) ||
    all_product_types;

  const [data, setData] = useState({
    product_types: initialProductTypes
  });

  useEffect(() => {
    setData({ product_types: initialProductTypes });
  }, [quoter, ltc_quoter]);

  const handleChecklistChange = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const save = () => {
    handleSave(data);
  };

  const selectAll = () => {
    if (data.product_types.length === all_product_types.length) {
      setData({
        ...data,
        product_types: []
      });
    } else {
      setData({
        ...data,
        product_types: all_product_types
      });
    }
  };

  return (
    <>
      <div style={{ display: 'flex', marginBottom: 30 }}>
        <Button inline={true} onClick={selectAll} small={true}>
          {data.product_types.length === all_product_types.length ? 'Unselect All' : 'Select All'}
        </Button>
      </div>

      <div style={{ display: 'flex', marginBottom: 30 }}>
        <div style={{ width: '25%' }}>
          <Field label='Term Life'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={TERM_LIFE_INSURANCE_PRODUCTS.map(p => ({ value: p }))}
              selected={data.product_types || []}
            />
          </Field>
        </div>

        <div style={{ width: '25%' }}>
          <Field label='Guaranteed Universal Life'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={GUARANTEED_UNIVERSAL_LIFE_PRODUCTS.map(p => ({ value: p }))}
              selected={data.product_types || []}
            />
          </Field>
        </div>

        <div style={{ width: '25%' }}>
          <Field label='Return of Premium'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={ROP_PRODUCTS.map(p => ({ value: p }))}
              selected={data.product_types || []}
            />
          </Field>
        </div>

        <div style={{ width: '25%' }}>
          <Field label='Other'>
            <Checklist
              onChange={handleChecklistChange.bind(null, 'product_types')}
              options={OTHER_PRODUCTS.map(p => ({ value: p }))}
              selected={data.product_types || []}
            />
          </Field>
        </div>
      </div>

      <Button disabled={!data.product_types.length} onClick={save}>
        Save Changes
      </Button>
    </>
  );
};

LimitProductTypes.propTypes = {
  // for universal quoter
  handleSave: PropTypes.func,
  ltc_quoter: PropTypes.object, // legacy
  quoter: PropTypes.object
};

export default LimitProductTypes;
